import { useRef } from "react";
import { useMediaQuery } from "react-responsive";

import { GameHandler, GameHandlerProps } from "../../types";
import { RatingScaleModal } from "./Modals/RatingScaleModal";
import { WordopolisBoard } from "./WordopolisBoard";
import { WordopolisContextProvider } from "../../contexts/wordopolis";
import { WordopolisGame as WordopolisGameType } from "../../graphql/helpers/isWordopolisGame";
import { WordopolisMobileBottom } from "./WordopolisMobileBottom";
import { WordopolisPanel } from "./WordopolisPanel";
import { WordsListModal } from "./Modals/WordsListModal";

import styles from "./WordopolisGame.module.scss";

export const WordopolisGame: GameHandler = (props: GameHandlerProps) => {
  const { game, finishGame } = props;

  const ref = useRef<HTMLDivElement>(null);
  const isDesktop = useMediaQuery({ query: "(min-width: 1280px)" });

  const backgroundColor = game.configuration?.gameVisuals.backgroundColor;
  const backgroundImage = game.configuration?.gameVisuals.backgroundImage;

  const backgroundColorStyle = !backgroundImage ? { backgroundColor } : undefined;
  const backgroundImageStyle = backgroundImage ? { backgroundImage: `url(${backgroundImage.url})` } : undefined;

  if (!("numberOfColumns" in game.configuration)) {
    throw new Error("Invalid game configuration");
  }

  return (
    <WordopolisContextProvider finishGame={finishGame} game={game as WordopolisGameType}>
      <div className={styles.wordopolisWrapper}>
        <div ref={ref} className={styles.wordopolisGame}>
          <WordopolisPanel />
          <WordopolisBoard parentRef={ref} />
          {!isDesktop && <WordopolisMobileBottom />}
        </div>

        {isDesktop && (
          <div className={styles.background} style={backgroundImageStyle}>
            <div className={styles.leftShadow} style={backgroundColorStyle}></div>
            <div className={styles.rightShadow} style={backgroundColorStyle}></div>
          </div>
        )}
      </div>
      <WordsListModal />
      <RatingScaleModal />
    </WordopolisContextProvider>
  );
};
